import { prefixObjectValues } from '../utils';

const helpMenu = {
  trigger: 'trigger',
  faqItem: 'faq-item',
  contactSupportItem: 'contact-support-item',
  typeSelect: 'type-select',
  subjectInput: 'subject-input',
  messageInput: 'message-input',
  sendButton: 'send-button',
  cancelButton: 'cancel-button',
};

export default prefixObjectValues(helpMenu, 'help-menu');
